import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { appStore } from "@/hooks";
import { TextButton } from "@/components/common";

/**
 * Renders a button to update the current project.
 */
const __default__ = {
  name: "UpdateButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(appStore).runUpdate)
    ? (_openBlock(), _createBlock(_unref(TextButton), {
        key: 0,
        text: "",
        label: "Load Changes",
        color: "primary",
        icon: "sync",
        "data-cy": "button-nav-load-update",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).loadAppChanges()))
      }))
    : _createCommentVNode("", true)
}
}

})